// src/navigation/navLinksAdmin.js
import {
  Home,
  LayoutDashboard,
  Building2,
  GraduationCap,
  School,
  Book,
  Share2,
  Users,
  UserPlus,
  ListChecks,
  FileSpreadsheet,
  Layers,
  Coins,
  Gavel,
  Headphones,
  MessageSquare,
  Settings,
  Briefcase,
  Percent,
  Presentation,
  Users2,
  ShieldAlertIcon,
  LockIcon,
} from "lucide-vue-next";

export const navLinksAdmin = [
  {
    title: "Dashboard",
    links: [
      {
        icon: Home,
        label: "Dashboard",
        href: "/dashboard",
        permission: "admin-dashboard.view",
      },
    ],
  },

  {
    title: "Cadastros",
    links: [
      {
        icon: Building2,
        label: "Departamentos",
        href: "/dashboard/departments",
        permission: "admin-departments.view",
      },
      {
        icon: GraduationCap,
        label: "Cursos",
        href: "/dashboard/courses",
        permission: "admin-courses.view",
      },
      {
        icon: School,
        label: "Turmas",
        href: "/dashboard/classmates",
        permission: "admin-classmates.view",
      },
      {
        icon: Book,
        label: "Disciplinas",
        href: "/dashboard/subject",
        permission: "admin-subjects.view",
      },
      {
        icon: Share2,
        label: "Precedências",
        href: "/dashboard/subject/precedences",
        permission: "admin-precedences.view",
      },
    ],
  },

  {
    title: "Professores",
    links: [
      {
        icon: Presentation,
        label: "Gerenciar",
        href: "/dashboard/teachers",
        permission: "admin-teachers.view",
      },
      {
        icon: LayoutDashboard,
        label: "Alocar Disciplinas/Turmas",
        href: "/dashboard/alocate_teacher_geral",
        permission: "admin-teachers-allocate.view",
      },
    ],
  },

  {
    title: "Estudantes",
    links: [
      {
        icon: Users,
        label: "Gerenciar",
        href: "/dashboard/all-students",
        permission: "admin-students.view",
      },
      {
        icon: UserPlus,
        label: "Alocar Estudantes",
        href: "/dashboard/enroll",
        permission: "admin-students-allocate.view",
      },
    ],
  },

  {
    title: "Pautas",
    links: [
      {
        icon: ListChecks,
        label: "Por Disciplina",
        href: "/dashboard/guidelines",
        permission: "admin-guidelines.view",
      },
      {
        icon: FileSpreadsheet,
        label: "Por Turma",
        href: "/dashboard/guidelinesByClassmate",
        permission: "admin-guidelines-classmate.view",
      },
    ],
  },

  {
    title: "Inscrições",
    links: [
      {
        icon: Layers,
        label: "Gerenciar",
        href: "/dashboard/all-inscriptions",
        permission: "admin-inscriptions.view",
      },
      {
        icon: LayoutDashboard,
        label: "Estatística",
        href: "/dashboard/inscription-statistic",
        permission: "admin-inscriptions-stat.view",
      },
    ],
  },

  {
    title: "Pagamentos",
    links: [
      {
        icon: Coins,
        label: "Pagamentos",
        href: "/dashboard/payments",
        permission: "admin-payments.view",
      },
      {
        icon: FileSpreadsheet,
        label: "Extrato",
        href: "/dashboard/payments/extract",
        permission: "admin-payments-extract.view",
      },
      {
        icon: Gavel,
        label: "Dívidas",
        href: "/dashboard/payments/debt",
        permission: "admin-payments-debt.view",
      },
      {
        icon: Coins,
        label: "Renovações/Inscrições",
        href: "/dashboard/payments/paymentInscriptions_renews",
        permission: "admin-payments-renews.view",
      },
    ],
  },

  {
    title: "Multas",
    links: [
      {
        icon: Gavel,
        label: "Adicionar",
        href: "/dashboard/fines/add",
        permission: "admin-fines.add",
      },
      {
        icon: Gavel,
        label: "Listar",
        href: "/dashboard/fines/list",
        permission: "admin-fines.list",
      },
    ],
  },

  {
    title: "Serviços",
    links: [
      {
        icon: Headphones,
        label: "Gerenciar Serviços",
        href: "/dashboard/services",
        permission: "admin-services.view",
      },
    ],
  },

  {
    title: "Atendimento",
    links: [
      {
        icon: MessageSquare,
        label: "Atendimento",
        href: "/dashboard/support",
        permission: "admin-support.view",
      },
      {
        icon: Headphones,
        label: "Formas",
        href: "/dashboard/support/forms",
        permission: "admin-support.forms.view",
      },
    ],
  },

  {
    title: "Configurações",
    links: [
      {
        icon: Settings,
        label: "Início das Inscrições",
        href: "/dashboard/activities/configure_inscription",
        permission: "admin-settings.inscriptions.view",
      },
      {
        icon: Settings,
        label: "Início do Ano Lectivo",
        href: "/dashboard/activities",
        permission: "admin-settings.activities.view",
      },
      {
        icon: Settings,
        label: "Data de Lançamento Notas",
        href: "/dashboard/activities/configure_dates",
        permission: "admin-settings.dates.view",
      },
      {
        icon: Settings,
        label: "Data de Lançamento Notas Exames",
        href: "/dashboard/activities/configure_dates_exames",
        permission: "admin-settings.exams.view",
      },
      {
        icon: Percent,
        label: "Percentagens",
        href: "/dashboard/percents",
        permission: "admin-settings.percents.view",
      },
      {
        icon: Coins,
        label: "Entidades",
        href: "/dashboard/entities",
        permission: "admin-settings.entities.view",
      },
      {
        icon: Coins,
        label: "Taxas de Matrícula & Mensalidades",
        href: "/dashboard/settings",
        permission: "admin-settings.fees.view",
      },
      {
        icon: Briefcase,
        label: "Dados da Empresa",
        href: "/dashboard/company_profile",
        permission: "admin-settings.company.view",
      },
    ],
  },

  {
    title: "Admin",
    links: [
      {
        icon: LockIcon,
        label: "Permissões",
        href: "/dashboard/permissions",
        permission: "admin-permissions.view",
      },
      {
        icon: ShieldAlertIcon,
        label: "Funções",
        href: "/dashboard/roles",
        permission: "admin-roles.view",
      },
      {
        icon: Users2,
        label: "Utilizadores",
        href: "/dashboard/users",
        permission: "admin-users.view",
      },
    ],
  },
];
